import { TypographyStyleOptions } from '@material-ui/core/styles/createTypography'

interface FontStyle {
    [key: string]: TypographyStyleOptions
}

const fontStyles: FontStyle = {
    body1: {
        fontFamily: 'Din',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: 1.0,
    },
    body2: {
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '1.1rem',
        // lineHeight: 1.3125,
    },
    subtitle1: {
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '0.75rem',
        // lineHeight: 0.875,
    },
    subtitle2: {
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '0.80rem',
        // lineHeight: 0.75,
    },
    button: {
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '0.9375rem',
        // lineHeight: 1.125,
        textTransform: 'uppercase',
    },
    FormTextSmall: {
        //h6
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '0.875rem',
        // lineHeight: 1,
    },
    SaveProgressTitle: {
        //h5
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '1.25rem',
        // lineHeight: 2.125,
    },
    Abschnittssubline: {
        //h4
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '1.375rem',
        // lineHeight: 1.625,
    },
    ProduktboxProduktTitel: {
        //h3
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1.5rem',
        // lineHeight: 1.75,
    },
    UbersichtTitel: {
        //h2
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1.5rem',
        // lineHeight: 2.125,
    },
    Abschnittsheadline: {
        //h1
        fontFamily: 'Din',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '2.5rem',
        // lineHeight: 3.375,
    },
}
export default fontStyles
